import { Button } from "antd";

interface IBVConfirmButton {
	setConfirmVisible: (visible: boolean) => void;
	timeRemaining: string;
}

const BVConfirmButton: React.FC<IBVConfirmButton> = ({
	setConfirmVisible,
	timeRemaining
}) => {
	return (
		<Button
			className="confirm-button"
			type="primary"
			size={"large"}
			onClick={() => setConfirmVisible(true)}
			disabled={timeRemaining === "TIME OUT"}
			style={{
				color: "#fff",
				borderColor: "#999999",
				backgroundColor: timeRemaining === "TIME OUT" 
                ? "#d9d9d9" : "#006400"
			}}
		>
			{"Confirm"}
		</Button>
	);
};

export default BVConfirmButton;